module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [_h('h3', ["お客様の声"]), " ", _h('div', {
    staticClass: "feedback card-container"
  }, [_h('div', {
    staticClass: "card"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title text-right"
  }, ["肩から腕の痛み・しびれ、腰痛"]), " ", _h('h5', {
    staticClass: "text-right"
  }, ["(40歳代 男性)", _h('h5')])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "整体を受けて症状は良くなりましたか？", _h('br'), "また、整体を受けられた感想をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), " ", _h('ul', [_h('li', ["痛みがほとんどなくなった"]), " ", _h('li', ["こちらの症状（どこが、どのように痛むのか等）をよく聞いてくれて、処置してくれるので、安心してお任せできる"])])]), " ", _h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "当院への率直なご意見（整体の内容・店主の人柄・店内の装飾など）をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), " ", _h('ul', [_h('li', ["店主が誠実：◎"]), " ", _h('li', ["店内も質素でよい：◎"])])])])]), " ", _h('div', {
    staticClass: "card"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title text-right"
  }, ["首の痛み、肩こり、腰痛"]), " ", _h('h5', {
    staticClass: "text-right"
  }, ["(20～39歳 女性)", _h('h5')])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "整体を受けて症状は良くなりましたか？", _h('br'), "また、整体を受けられた感想をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "体が楽になりました。\n        "]), " ", _h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "当院への率直なご意見（整体の内容・店主の人柄・店内の装飾など）をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "店主の人柄もよくリラックスしてうけられます。港区から来てますが、今後もこちらに通う予定です。\n        "])])]), " ", _h('div', {
    staticClass: "card"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title text-right"
  }, ["腰痛、ひざの痛み、坐骨神経痛"]), " ", _h('h5', {
    staticClass: "text-right"
  }, ["(60歳代 女性)", _h('h5')])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "整体を受けて症状は良くなりましたか？", _h('br'), "また、整体を受けられた感想をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "最初週２回から週１回、１０日に１回と続けている内１年半過ぎた今では月１回受けており、すべての痛みが消え本当にうれしく思っております。何をやっても良くならなかったのが先生に出合え助けていただき感謝しております。\n        "]), " ", _h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "当院への率直なご意見（整体の内容・店主の人柄・店内の装飾など）をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "院内も清潔で先生の人柄も良く、お話ししながらの１時間はアッと言う間に過ぎ治療というより癒しに伺う気分で料金も安く有難いです。\n        "])])]), " ", _h('div', {
    staticClass: "card"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title text-right"
  }, ["ひざの痛み、変形ひざ関節症"]), " ", _h('h5', {
    staticClass: "text-right"
  }, ["(70歳代 女性)", _h('h5')])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "整体を受けて症状は良くなりましたか？", _h('br'), "また、整体を受けられた感想をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "整体治療を受け１０ヶ月になりますが脚のコルセットを外し杖を忘れるほど歩行が楽になりました。感謝致しております。\n        "]), " ", _h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "当院への率直なご意見（整体の内容・店主の人柄・店内の装飾など）をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "胡弓の曲が流れとてもリラックス出来ます。先生は気さくなお人柄で世間話をしながら整体をして頂いております。"])])]), " ", _h('div', {
    staticClass: "card"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title text-right"
  }, ["頭痛、肩こり、ひざの痛み"]), " ", _h('h5', {
    staticClass: "text-right"
  }, ["（40歳代　女性）", _h('h5')])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "整体を受けて症状は良くなりましたか？", _h('br'), "また、整体を受けられた感想をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "受診後は少しだるさがあったりしますが、必ず翌々日からすっきりと楽になります。"]), " ", _h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "当院への率直なご意見（整体の内容・店主の人柄・店内の装飾など）をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "いつも院内には花や観葉植物が元気に活々としていて心地よいです。"])])]), " ", _h('div', {
    staticClass: "card"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title text-right"
  }, ["肩こり、更年期の諸症状"]), " ", _h('h5', {
    staticClass: "text-right"
  }, ["(40歳代 女性)", _h('h5')])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "整体を受けて症状は良くなりましたか？", _h('br'), "また、整体を受けられた感想をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "肩こりは、ある一定期間症状が治まります。その周期は若干ですが、伸びてきたように思います。更年期のどうき、めまい、不安感は治まりました。特に不安感は、先生の大らかさで解消されました。ありがとうございます。"]), " ", _h('p', [_h('span', {
    staticClass: "question"
  }, ["Q."]), "当院への率直なご意見（整体の内容・店主の人柄・店内の装飾など）をお聞かせ下さい。"]), " ", _h('p', {
    staticClass: "text-orange"
  }, [_h('span', {
    staticClass: "answer"
  }, ["A."]), "緊張するタイプですが、最初からリラックスできました。いつも変わらない節度ある応対は、やはり先生のお人柄の良さです。"])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-190924d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/Feedback.vue
// module id = 428
// module chunks = 0